/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useState } from "react";
import { GblContext } from "providers/formatter";
import { makeStyles } from "@material-ui/core/styles";
import { getPasswordPolicy, updatePasswordPolicy } from "services/setting";
import { Box, Divider, Grid, Typography } from "@material-ui/core";
import AccessDenied from "layout/AccessDenied";
import SnackbarUtils from "utils/SnackbarUtils";
import ActionMenu from "components/ActionMenu";
import ButtonFooter from "components/ButtonFooter";
import { useForm } from "react-hook-form";
import { TextFieldInForm } from "components/Form";

const useStyles = makeStyles((theme) => ({
  root: { textAlign: "center" },
  tabPanel: { width: "100%", margin: "0 20px" },
  button: { textTransform: "none" },
}));

const PasswordPolicy = (props) => {
  const { children, value, index } = props;
  const classes = useStyles();
  const { ToNumber } = useContext(GblContext);
  const [isBtnLoading, setBtnLoading] = useState(false);
  const [mode, setMode] = useState("view");
  const [setting, setSetting] = useState();
  const methods = useForm({ defaultValues: setting });
  const { handleSubmit, reset } = methods;

  const fetch = async () => {
    const r = await getPasswordPolicy();
    if (r && r !== "") {
      setSetting(r);
      reset(r);
    } else {
      setSetting();
      reset();
    }

    setBtnLoading(false);
  };

  React.useEffect(() => {
    if (value === index) {
      fetch();
    }
  }, [value]);

  const disableFormEnter = (e) => {
    if (e.key === "Enter" && e.target.localName !== "textarea")
      e.preventDefault();
  };

  const onSubmit = async (values) => {
    setBtnLoading(true);
    const payload = {
      ...setting,
      MinimumPasswordLength: ToNumber(values.MinimumPasswordLength),
      PasswordExpiredEvery: values.PasswordExpiredEvery,
    };

    const { Code, UserMessage } = await updatePasswordPolicy(payload);
    if (Code === 0) {
      SnackbarUtils.success(UserMessage);
      setMode("view");
      fetch();
    } else {
      SnackbarUtils.warning(UserMessage);
      setBtnLoading(false);
    }
  };

  const menuControlProp = [
    {
      name: "Edit",
      fnc: () => {
        setMode("edit");
      },
      disabled: mode !== "view",
    },
  ];

  const CancelFnc = () => {
    methods.clearErrors();
    fetch();
    setMode("view");
  };

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      className={classes.tabPanel}
    >
      {setting && value === index ? (
        <>
          <Box p={3}>
            <Typography>
              <b>{children}</b>
            </Typography>
          </Box>
          <div style={{ marginTop: -74 }}>
            <ActionMenu menuControl={menuControlProp} />
          </div>
          <Divider />
          <form
            onSubmit={handleSubmit(onSubmit)}
            onKeyDown={disableFormEnter}
            onError={(v) => console.log(v)}
          >
            <Box
              p={1}
              display="flex"
              alignItems="center"
              justifyContent="space-between"
            >
              <Box flexGrow={1}>
                <Grid
                  container
                  direction="row"
                  justifyContent="start"
                  alignItems="center"
                >
                  <Typography variant="subtitle1">Password Length</Typography>
                </Grid>
                <Typography variant="caption" style={{ color: "#9D9D9D" }}>
                  Min 6, Max 18 digits 0 = No limit
                </Typography>
              </Box>
              <Box>
                <TextFieldInForm
                  name="MinimumPasswordLength"
                  methods={methods}
                  variant="outlined"
                  margin="dense"
                  readOnly
                  fullWidth
                  rule={{
                    max: {
                      value: 18,
                      message: "maximum digit is 18",
                    },
                  }}
                  inputProps={{
                    min: 6,
                    max: 18,
                    style: { textAlign: "right" },
                  }}
                />
              </Box>
            </Box>
            <Box
              p={1}
              display="flex"
              alignItems="center"
              justifyContent="space-between"
            >
              <Box flexGrow={1}>
                <Grid
                  container
                  direction="row"
                  justifyContent="start"
                  alignItems="center"
                >
                  <Typography variant="subtitle1">Expiry (Days)</Typography>
                </Grid>
                <Typography variant="caption" style={{ color: "#9D9D9D" }}>
                  Max 365, 0 = No expiry date
                </Typography>
              </Box>
              <Box>
                <TextFieldInForm
                  name="PasswordExpiredEvery"
                  methods={methods}
                  variant="outlined"
                  margin="dense"
                  readOnly
                  fullWidth
                  rule={{
                    max: {
                      value: 365,
                      message: "maximum days is 365",
                    },
                  }}
                  inputProps={{
                    style: { textAlign: "right" },
                  }}
                />
              </Box>
            </Box>
            {mode !== "view" && (
              <ButtonFooter disabled={isBtnLoading} CancelFnc={CancelFnc} />
            )}
          </form>
          <pre>
            {process.env.NODE_ENV === "development"
              ? JSON.stringify(setting, 0, 2)
              : ""}
          </pre>
        </>
      ) : (
        <AccessDenied />
      )}
    </div>
  );
};

export default PasswordPolicy;
